var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-container"},[_c('Spinner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }